const API_BASE = import.meta.env.DEV ? '' : 'https://kidstube-api.nineforge.com';

export function apiUrl(path: string) {
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  return `${API_BASE}${path.startsWith('/') ? path : `/${path}`}`;
}

type ApiFetchOptions = RequestInit & { json?: unknown };

export async function apiFetch<T = unknown>(path: string, options: ApiFetchOptions = {}): Promise<T> {
  const { json, headers, ...rest } = options;
  const finalHeaders: Record<string, string> = { ...(headers || {}) } as Record<string, string>;
  let body = rest.body;

  if (json !== undefined) {
    finalHeaders['Content-Type'] = 'application/json';
    body = JSON.stringify(json);
  }

  const res = await fetch(apiUrl(path), {
    ...rest,
    headers: finalHeaders,
    credentials: 'include',
    body,
  });

  if (!res.ok) {
    let message = res.statusText;
    try {
      const data = await res.json() as { error?: string };
      message = data?.error || message;
    } catch {
      // ignore
    }
    throw new Error(message);
  }

  if (res.status === 204) {
    return null as T;
  }

  return res.json() as Promise<T>;
}
